"use client"

import { Button, Popover, Row, Select, SelectProps } from "antd"

import Title from "@/components/common/Typography/Title"
import InputAdult from "./InputAdult"
import InputChildren from "./InputChildren"
import InputRoom from "./InputRoom"
import { FC, useState } from "react"
import { useAppSelector } from "@/lib/redux/hooks"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown, faDoorOpen } from "@fortawesome/free-solid-svg-icons"
import Text from "@/components/common/Typography/Text"
import { useTranslation } from "react-i18next"

type SelectRoomAndPeopleProps = Omit<SelectProps, 'size'> & {
  size?: 'small' | 'default'
}

const SelectRoomAndPeople: FC<SelectRoomAndPeopleProps> = ({ size, ...props }) => {
  const [open, setOpen] = useState<boolean>(false)
  const { t } = useTranslation()
  const { adults, children, roomsNum } = useAppSelector(state => {
    return {
      adults: state.hotel.formSearch.adults,
      children: state.hotel.formSearch.children,
      roomsNum: state.hotel.formSearch.roomsNum,
    }
  })

  const isSmall = size == 'small'
  const summary = `${roomsNum} ${t("hotel.room")}, ${adults} ${t("common.adult")}, ${children} ${t("common.child")}`

  const selector = (
    <Select
      prefix={isSmall ? undefined : <Text type='secondary'><FontAwesomeIcon icon={faDoorOpen} /></Text>}
      value={summary}
      onClick={() => setOpen(rev => !rev)}
      open={false}
      className={`home__searching--select-people${isSmall ? ' home__searching--input' : ''}`}
      popupMatchSelectWidth={false}
      listHeight={400}
      labelRender={() => summary}
      options={[]}
      {...props}
      {...(isSmall ? {
        variant: 'borderless'
      } : {})}
      size={isSmall ? undefined : 'large'}
    />
  )

  let content

  if (!isSmall) {
    content = selector
  } else {
    content = (
      <div
        className="home__searching--field-control home__searching--field-control--stacked"
        onClick={() => setOpen(true)}
      >
        <Text className="home__searching--field-label">{t("hotel.room_people")}</Text>
        <div className="home__searching--field-control-row">
          <span className="home__searching--field-icon" aria-hidden>
            <FontAwesomeIcon icon={faDoorOpen} />
          </span>
          <span className="home__searching--hotel-guest-value">{summary}</span>
          <FontAwesomeIcon icon={faChevronDown} className="home__searching--field-chevron" aria-hidden />
        </div>
      </div>
    )
  }

  return (
    <Popover
      open={open}
      trigger={['click']}
      placement='bottomLeft'
      arrow={false}
      classNames={{ root: "home__searching--hotel-guests-popover" }}
      styles={{
        content: {
          maxWidth: '42rem'
        }
      }}
      content={(
        <div className="home__searching--hotel-guests">
          <Title className="home__searching--hotel-guests-title" level={5} style={{ marginTop: 0 }}>{t("hotel.numbers_of_room_people")}</Title>
          <InputRoom />
          <InputAdult />
          <InputChildren />
          <Row style={{ marginTop: '1.2rem' }}>
            <Button onClick={() => setOpen(false)} block type='primary'>{t("common.done")}</Button>
          </Row>
        </div>
      )}
    >
      {content}
    </Popover>
  )
}

export default SelectRoomAndPeople